import { IRegionShort } from 'api/region/types';
import { Diagnostics } from 'util/diagnostics';
import { getRegionSlugsCache } from 'util/memcache';

let data: Array<IRegionShort> | undefined;

export const fetchRegionSlugs = async (tag: string) => {
  if (!data) {
    try {
      const cached = await getRegionSlugsCache();
      if (cached.data && cached.data.length) {
        data = cached.data;
        Diagnostics.message({ message: 'getStaticPaths used memcache', tag });
      }
    } catch (e: any) {
      Diagnostics.error({ message: 'getStaticPaths cache failed to load ', tag, error: e });
    }
  } else {
    Diagnostics.message({ message: 'getStaticPaths used in-memory data', tag });
  }
  Diagnostics.message({ message: `Region getStaticPaths has ${data?.length} regions`, tag });
  return data!.filter((v) => !v.domain);
};
